import { render, staticRenderFns } from "./SelectDesign.vue?vue&type=template&id=412d54be&scoped=true"
import script from "./SelectDesign.vue?vue&type=script&lang=js"
export * from "./SelectDesign.vue?vue&type=script&lang=js"
import style0 from "./SelectDesign.vue?vue&type=style&index=0&id=412d54be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412d54be",
  null
  
)

export default component.exports